import logo from './logo.svg';
import './App.css';
import { Home } from './Home';


function App() {
  return (
   <div>
  <Home></Home>
   </div>
  );
}

export default App;
